module.exports = __webpack_public_path__ + "d5cf1991483192c7223a61a35c769da5.png";